import { render } from "./NewGroupTutors.vue?vue&type=template&id=5e215d15&scoped=true"
import script from "./NewGroupTutors.vue?vue&type=script&lang=js"
export * from "./NewGroupTutors.vue?vue&type=script&lang=js"

import "./NewGroupTutors.vue?vue&type=style&index=0&id=5e215d15&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e215d15"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QList,QExpansionItem,QToggle});
